// extracted by mini-css-extract-plugin
module.exports = {"attendantInfo":"styles_attendantInfo__1iP70","chatInfo":"styles_chatInfo__AQG2m","infoItem":"styles_infoItem__22oaM","itemIcon":"styles_itemIcon__1OoQu"};